<template>
  <div class="layout">
    <full-loader v-if="loading" />
    <error-page v-else-if="error" />
    <Layout v-else>
      <nav-panel></nav-panel>
      <Content>
        <div class="layout-cover"></div>
        <div class="layout-inner">
          <router-view></router-view>
        </div>
      </Content>
    </Layout>

    <about-modal />
    <download-widget />
  </div>
</template>

<script>
import FullLoader from '@/components/loaders/full-loader'
import ErrorPage from '@/components/errors/error-page'
import NavPanel from '@/components/nav-panel/nav-panel'
import AboutModal from '@/components/about/about-modal'
import DownloadWidget from '@/components/resources/download-widget'
import { saveDataToLS } from '@/utils'
import { usersListConfig } from '@/config/users'
import { permissionGroups } from '@/config/permissions'

const modifyCrud = ({ creat, read, updat, delet }) => ({
  create: creat,
  update: updat,
  delete: delet,
  read
})
const getPermissions = permissions =>
  permissions.reduce((prev, { code, interface_permission }) => {
    prev[code] = modifyCrud(interface_permission)
    return prev
  }, {})

export default {
  data () {
    return {
      error: false
    }
  },
  components: {
    NavPanel,
    FullLoader,
    ErrorPage,
    AboutModal,
    DownloadWidget
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    },
    loading () {
      return this.$store.state.appLoading
    }
  },
  methods: {
    startSocketConnection () {
      const types = ['create', 'update', 'delete']
      // const { token } = this.$store.state.auth

      this.$socket.io.opts.query = { token: this.$store.state.auth.user.id, role: this.$store.state.auth.user.role_status }
      this.$socket.open()

      types.forEach(type => {
        this.$socket.on(`data.${type}`, message => {
          const { source_id } = message

          console.log('SOCKET UPDATE --- ', message)

          this.$store.commit('SET_UPDATE_TYPE', source_id)
          this.$store.commit('TOGGLE_SOCKET_STATE', { type, value: true })
        })
      })

      this.$socket.on('notifications', messages => {
        this.$store.commit('TOGGLE_IS_NEW', true)
        messages.forEach(msg => {
          this.$Notice.info({
            title: 'Уведомление системы',
            desc: msg
          })
        })
      })
    },
    saveAppParams () {
      const {
        company,
        contracts,
        amendments,
        contragents,
        acts,
        actsMode,
        payments,
        lawCases,
        resources,
        experience,
        timeTable,
        contractsRegister
      } = this.$store.state.filters
      const { theme } = this.$store.state

      saveDataToLS('company', company)
      saveDataToLS('contracts', contracts)
      saveDataToLS('amendments', amendments)
      saveDataToLS('contragents', contragents)
      saveDataToLS('acts', acts)
      saveDataToLS('actsMode', actsMode)
      saveDataToLS('payments', payments)
      saveDataToLS('lawCases', lawCases)
      saveDataToLS('resources', resources)
      saveDataToLS('experience', experience)
      saveDataToLS('timeTable', timeTable)
      saveDataToLS('contractsRegister', contractsRegister)
      saveDataToLS('theme', theme)
    },
    async getPermissions () {
      const url = 'page/permission'
      const permissionsArray = await this.$store.dispatch('GET_REQUEST', {
        url
      })

      const permissions = permissionGroups.reduce((prev, el) => {
        const array = permissionsArray.filter(p => p.group_name === el.group)
        const hashPerms = getPermissions(array)

        if (el.code === 'books' || el.code === 'contract') {
          prev[el.code] = hashPerms
        } else {
          prev = {
            ...prev,
            ...hashPerms
          }
        }

        return prev
      }, {})

      console.log('user permissions --- ', permissions)

      this.$store.commit('SET_PERMISSIONS', permissions)
      saveDataToLS('permissions', permissions)
    }
  },
  async created () {
    try {
      this.error = false
      this.$store.commit('SET_APP_LOADING', true)

      await this.getPermissions()

      const user = await this.$store.dispatch('GET_REQUEST', {
        url: 'current_user'
      })
      const companies = await this.$store.dispatch('GET_REQUEST', {
        url: 'page/own_company'
      })
      const users = await this.$store.dispatch('GET_REQUEST', {
        url: `objectInfo/users?config=${JSON.stringify(usersListConfig)}`
      })
      const statuses = await this.$store.dispatch('GET_REQUEST', {
        url: 'objectInfo/contract_statuses'
      })
      const positions = await this.$store.dispatch('GET_REQUEST', {
        url: 'objectInfo/positions'
      })

      this.$store.commit('SET_REPORTS_VALUE', {
        field: 'status',
        value: statuses.find(s => s.name === 'Активен').id
      })

      this.$store.commit('SET_COMPANIES', companies)
      this.$store.commit('SET_CONTRACT_STATUSES', statuses)
      this.$store.commit('SET_USERS', users)
      this.$store.commit('SET_POSITIONS', positions)
      this.$store.commit('SET_USER', user)

      this.startSocketConnection()
      this.$store.commit('SET_APP_LOADING', false)
    } catch (error) {
      console.log(error)
      this.$store.commit('SET_APP_LOADING', false)
      this.error = true
    }

    window.addEventListener('beforeunload', this.saveAppParams)
  }
}
</script>

<style lang="less">
.layout {
  position: relative;
  overflow: hidden;

  .ivu-layout {
    min-height: 100vh;

    &-content {
      position: relative;
    }
  }

  &-inner {
    position: relative;
  }

  &-cover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
